export var SuperintendentVisitType;
(function (SuperintendentVisitType) {
    SuperintendentVisitType[SuperintendentVisitType["MoveInOrientation"] = 1] = "MoveInOrientation";
    SuperintendentVisitType[SuperintendentVisitType["MoveOutConsultation"] = 2] = "MoveOutConsultation";
})(SuperintendentVisitType || (SuperintendentVisitType = {}));
export var SuperintendentBookingStatus;
(function (SuperintendentBookingStatus) {
    SuperintendentBookingStatus["Bookable"] = "Bookable";
    SuperintendentBookingStatus["LinkReplaced"] = "LinkReplaced";
    SuperintendentBookingStatus["LinkExpired"] = "LinkExpired";
    SuperintendentBookingStatus["WindowClosed"] = "WindowClosed";
    SuperintendentBookingStatus["NoActiveWorkOrder"] = "NoActiveWorkOrder";
    SuperintendentBookingStatus["Unavailable"] = "Unavailable";
    SuperintendentBookingStatus["InvalidToken"] = "InvalidToken";
})(SuperintendentBookingStatus || (SuperintendentBookingStatus = {}));
export var SuperintendentLinkRevokedReason;
(function (SuperintendentLinkRevokedReason) {
    SuperintendentLinkRevokedReason["Replaced"] = "Replaced";
    SuperintendentLinkRevokedReason["Cancelled"] = "Cancelled";
})(SuperintendentLinkRevokedReason || (SuperintendentLinkRevokedReason = {}));
export var SuperintendentBookingErrorCode;
(function (SuperintendentBookingErrorCode) {
    SuperintendentBookingErrorCode["InvalidToken"] = "INVALID_TOKEN";
    SuperintendentBookingErrorCode["SlotUnavailable"] = "SLOT_UNAVAILABLE";
    SuperintendentBookingErrorCode["InvalidRequest"] = "INVALID_REQUEST";
})(SuperintendentBookingErrorCode || (SuperintendentBookingErrorCode = {}));
